import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { components } from 'react-select';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function MultiValueRemove(_ref) {
  var innerProps = _ref.innerProps,
      rest = _objectWithoutProperties(_ref, ["innerProps"]);

  var innerPropsWithOutRemoval = _objectSpread(_objectSpread({}, innerProps), {}, {
    onClick: function onClick() {},
    onTouchEnd: function onTouchEnd() {},
    onMouseDown: function onMouseDown() {}
  });

  return /*#__PURE__*/React.createElement(components.MultiValueRemove, _extends({}, rest, {
    innerProps: innerPropsWithOutRemoval
  }), ",");
}

export default MultiValueRemove;
//# sourceMappingURL=MultiValueRemove.js.map
